const onCompanyPageMatch = async (pathname, regex) => {
  // Extract contact ID from URL
  const contactIdMatch = pathname.match(/\/edit-company\/(\d+)/)
  const contactId = contactIdMatch ? contactIdMatch[1] : null

  if (!contactId) {
    return
  }

  const getActiveCompanyEditId = () =>
    window.location.pathname.match(/\/edit-company\/(\d+)/)?.[1] || null

  // After Speichern, company view must drop Kontaktieren-via cache (same as person view)
  const markCompanyViewNeedsRefreshOnSpeichern = () => {
    if (window.__impowerxCompanyViewStaleListenerInstalled) return
    window.__impowerxCompanyViewStaleListenerInstalled = true
    document.addEventListener(
      'click',
      (event) => {
        const button = event.target?.closest?.('button')
        if (!button) return
        const label = (button.textContent || '').replace(/\s+/g, ' ').trim()
        const isSave =
          label === 'Speichern' ||
          label === 'Speichern und Weiter' ||
          label === 'Save' ||
          label === 'Save and Continue'
        if (!isSave) return
        const editId = getActiveCompanyEditId()
        if (!editId) return
        window.__impowerxCompanyViewNeedsRefresh = editId
      },
      true,
    )
  }
  markCompanyViewNeedsRefreshOnSpeichern()

  const initializeTaxAssumption = () => {
    const infoDiv = document.querySelector('#info')
    if (infoDiv) {
      taxAssumptionEditor(baseApiUrl)
    }
  }

  initializeContactReportingsField()
  initializeCompanyInvoiceFields()
  initializeTaxAssumption()
  initMultiContactUi()
  initContactRolesField()
  initKontaktierenViaDispatchPreferences({
    mode: 'edit',
    getContactId: () =>
      window.location.pathname.match(/\/edit-company\/(\d+)/)?.[1] || null,
  })

  // Set up MutationObserver to watch for DOM changes
  // Keep observer running so it can re-initialize the field if elements are removed/re-added during navigation
  const observer = new MutationObserver(() => {
    initializeContactReportingsField()
    initializeCompanyInvoiceFields()
    initializeTaxAssumption()
    initMultiContactUi()
    initContactRolesField()
    initKontaktierenViaDispatchPreferences({
      mode: 'edit',
      getContactId: () =>
        window.location.pathname.match(/\/edit-company\/(\d+)/)?.[1] || null,
    })
  })

  // Start observing the document body for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  })
}
